import SubGroupAccountActionTypes from './subGroupAccount.types';

/** ***************** ADD SUB GROUP ACCOUNT DETAILS START *********************** */
export const addSubGroupAccountDetailsStart = (addData: any) => ({
	type: SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const addSubGroupAccountDetailsSuccess = (successData: any) => ({
	type: SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const addSubGroupAccountDetailsFailure = (failureData: any) => ({
	type: SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const addSubGroupAccountDetailsResponseReset = () => ({
	type: SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const addSubGroupAccountDetailsResponseChanged = () => ({
	type: SubGroupAccountActionTypes.ADD_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS START *********************** */
export const updateSubGroupAccountDetailsStart = (updateData: any) => ({
	type: SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_START,
	payload: updateData,
});

export const updateSubGroupAccountDetailsSuccess = (successData: any) => ({
	type: SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const updateSubGroupAccountDetailsFailure = (failureData: any) => ({
	type: SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const updateSubGroupAccountDetailsResponseReset = () => ({
	type: SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const updateSubGroupAccountDetailsResponseChanged = () => ({
	type: SubGroupAccountActionTypes.UPDATE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** GET SUB GROUP ACCOUNT LIST START *********************** */
export const getSubGroupAccountListStart = (getData: any) => ({
	type: SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_START,
	payload: getData,
});

export const getSubGroupAccountListSuccess = (successData: any) => ({
	type: SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_SUCCESS,
	payload: successData,
});

export const getSubGroupAccountListFailure = (failureData: any) => ({
	type: SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_FAILURE,
	payload: failureData,
});

export const getSubGroupAccountListResponseReset = () => ({
	type: SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_RESPONSE_RESET,
});

export const getSubGroupAccountListResponseChanged = () => ({
	type: SubGroupAccountActionTypes.GET_SUB_GROUP_ACCOUNT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET SUB GROUP ACCOUNT LIST END *********************** */

/** ***************** FETCH SUB GROUP ACCOUNT DETAILS START *********************** */
export const fetchSubGroupAccountDetailsStart = (addData: any) => ({
	type: SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const fetchSubGroupAccountDetailsSuccess = (successData: any) => ({
	type: SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchSubGroupAccountDetailsFailure = (failureData: any) => ({
	type: SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchSubGroupAccountDetailsResponseReset = () => ({
	type: SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const fetchSubGroupAccountDetailsResponseChanged = () => ({
	type: SubGroupAccountActionTypes.FETCH_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH SUB GROUP ACCOUNT DETAILS END *********************** */

/** ***************** DELETE SUB GROUP ACCOUNT DETAILS START *********************** */
export const deleteSubGroupAccountDetailsStart = (addData: any) => ({
	type: SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_START,
	payload: addData,
});

export const deleteSubGroupAccountDetailsSuccess = (successData: any) => ({
	type: SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteSubGroupAccountDetailsFailure = (failureData: any) => ({
	type: SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteSubGroupAccountDetailsResponseReset = () => ({
	type: SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_RESET,
});

export const deleteSubGroupAccountDetailsResponseChanged = () => ({
	type: SubGroupAccountActionTypes.DELETE_SUB_GROUP_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});
/** ***************** DELETE SUB GROUP ACCOUNT DETAILS END *********************** */
